// extracted by mini-css-extract-plugin
module.exports = {"button":"DiscordLogin_button__2J1a4"};